import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Languages } from '../../../constants';
import {
  CenteredTimeDisplayTypography,
  TimeSliderDialog,
} from './component-utils';
import { GranularityPicker } from './GranularityPicker';
import { PresetPicker } from './PresetPicker';
import { StartEndPicker } from './StartEndPicker';
import { TimeSliderHandle } from './types';
import { displayDateRange } from './utils-display';

export const TimeSliderRange = ({
  timeSliderRangeHandle,
  selectedLanguage,
}: {
  timeSliderRangeHandle: TimeSliderHandle;
  selectedLanguage: Languages;
}) => {
  const [opened, setOpened] = useState(false);
  const [state] = timeSliderRangeHandle;

  return (
    <Grid
      item
      container
      xs={12}
      justifyContent="center"
      alignItems="center"
      className="intercom_dashboard-time-slider"
    >
      {!opened && (
        <CenteredTimeDisplayTypography
          id="time-range-label"
          role="button"
          aria-haspopup="dialog"
          aria-expanded={opened}
          onMouseEnter={() => setOpened(true)}
          className="intercom_timeslider"
          color={'textPrimary'}
        >
          {displayDateRange(
            state.start,
            state.end,
            state.selectedGranularity,
            selectedLanguage
          )}
        </CenteredTimeDisplayTypography>
      )}
      <TimeSliderDialog
        opened={opened}
        setOpened={setOpened}
        id="time-range-dialog"
        aria-labelledby="time-range-label"
      >
        <Grid item container justifyContent="center">
          <Grid item xs={12} style={{ maxHeight: 20 }}>
            <Typography variant="subtitle1">&nbsp;</Typography>
          </Grid>
          <PresetPicker />
          <StartEndPicker />
          <GranularityPicker />
        </Grid>
      </TimeSliderDialog>
    </Grid>
  );
};
